
import { AlertCircle, RefreshCw } from "lucide-react";
import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface CoursesErrorProps {
  error: Error | unknown;
  onRetry: () => void;
}

export function CoursesError({ error, onRetry }: CoursesErrorProps) {
  return (
    <div className="p-8">
      <Alert variant="destructive" className="mb-4">
        <AlertCircle className="h-5 w-5" />
        <AlertTitle>Error loading courses</AlertTitle>
        <AlertDescription>
          {error instanceof Error ? error.message : 'Unknown error'}
          <div className="mt-2 text-sm">
            This could be due to:
            <ul className="list-disc pl-5 mt-1 space-y-1">
              <li>Database permission issues</li>
              <li>Network connection problems</li>
              <li>Authentication issues with Supabase</li>
            </ul>
          </div>
        </AlertDescription>
      </Alert>
      <div className="flex gap-2">
        <Button onClick={onRetry} className="flex items-center gap-2">
          <RefreshCw className="h-4 w-4" />
          Try Again
        </Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload Page
        </Button>
      </div>
    </div>
  );
}
